import React, { Component } from "react";
import { Row, Col, Card, Table, Button, Modal, ModalHeader } from "reactstrap";
import CgnLoader from "../toolbox/CgnLoader";
import ContentTop from "../root/ContentTop";
import CgnAlert from "../toolbox/CgnAlert";
import CgnDatatable from "../toolbox/CgnDatatable";
import CgnMessage from "../toolbox/CgnMessage";
import "react-confirm-alert/src/react-confirm-alert.css";
import axios from "axios";
import {
  URL,
  
  fotoStyle,
  localFilePath,
} from "../../redux/actions/constants";
import noImg from "../../images/no-img.png";
import CgnReactSelect from "../toolbox/CgnReactSelect";
import CgnButton from "../toolbox/CgnButton";

class MachinePieceProductList extends Component {
  state = {
    pageTitle: "Ürün Adet Listele",
    breadcrumb: [{ text: "Ürün", link: "#" }],
    isLoading: false,
    productData: [],
    alertErrorMessage: "",
    image: "",
    name: "",
    isOpen: false,
    locationArr: [],
    locationGuid: "00000000-0000-0000-0000-000000000000",
  };

  async componentDidMount() {
    this.setState({
      isLoading: true,
    });

    // 
    var config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };

    axios
      .get(URL + "/locations/getlist/2", config)
      .then((response) => {
        var myArr = response.data.map(function (item) {
          return {
            value: item.guid,
            label: item.name,
          };
        });
        this.setState({
          locationArr: myArr,
        });
      })
      .catch((error) => {
        this.setState({
          alertErrorMessage: error.response.data,
          isLoading: false,
        });
      });

    this.getList(null);
  }

  getList = async () => {
    this.setState({
      isLoading: true,
    });
    var config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    var URLParam = "";
    var statusType = 2;
    URLParam = "/machineStocks/getlistallstock/" + statusType;

    if (this.state.locationGuid !== "00000000-0000-0000-0000-000000000000") {
      URLParam =
        "/machineStocks/getlistallstocklocation/" + this.state.locationGuid;
    }

    await axios
      .get(URL + URLParam, config)
      .then((response) => {
        this.setState({
          productData: response.data,
          isLoading: false,
        });
      })
      .catch((error) => {
        this.setState({
          alertErrorMessage: error.response.data,
          isLoading: false,
        });
      });
  };

  handleLocationSelectChange(option) {
    if (option) {
      this.setState({
        locationGuid: option.value,
        locationGuidError: "",
        alertErrorMessage: "",
      });
    } else {
      this.setState({
        locationGuid: "00000000-0000-0000-0000-000000000000",
        locationGuidError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
  }

  handleExcel = async () => {
    this.setState({
      isLoading: true,
    });
    var config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    var URLParam = "";
    var statusType = 2;
    URLParam = "/machineStocks/getlistallstockexcel/" + statusType;

    if (this.state.locationGuid !== "00000000-0000-0000-0000-000000000000") {
      URLParam =
        "/machineStocks/getlistallstocklocationexcel/" + this.state.locationGuid;
    }

    await axios
      .get(URL + URLParam, config)
      .then((response) => {
        var myData = response.data;
        let replaceLink = myData.replace(localFilePath, "");
        if (replaceLink) {
          window.open(replaceLink, "_blank");
          this.setState({
            isLoading: false,
          });
        }
      })
      .catch((error) => {
        this.setState({
          alertErrorMessage: error.response.data,
          isLoading: false,
        });
      });
  };

  toggle = (image, name) => {
    this.setState({
      isOpen: !this.state.isOpen,
      image: image,
      name: name,
    });
  };

  thStyle = {
    width: "100px",
  };

  thStyle2 = {
    width: "90px",
  };

  tdStyle = {
    width: "200px",
  };

  render() {
    return (
      <>
        <ContentTop
          breadcrumb={this.state.breadcrumb}
          title={this.state.pageTitle}
          excelLink={(onClick) => this.handleExcel()}
        />
        <Row className="productList" id="list">
          <Col>
            <Card body>
              <CgnLoader visibled={this.state.isLoading} />
              {this.state.alertErrorMessage && (
                <CgnAlert
                  color="danger"
                  title={CgnMessage.alertErrorTitle}
                  text={this.state.alertErrorMessage}
                />
              )}
              <Row className="filterRow">
                <Col className="pl-0 pr-2" lg="10">
                  <CgnReactSelect
                    name="locationGuid"
                    label="Depo"
                    placeholder="Depo seçiniz..."
                    selectValue={this.state.locationGuid}
                    isMulti={false}
                    isClearable={true}
                    onChange={(option) =>
                      this.handleLocationSelectChange(option)
                    }
                    options={this.state.locationArr}
                  />
                </Col>
                <Col className="pl-2 pr-0">
                  <CgnButton
                    type="button"
                    color="primary"
                    onClick={this.getList}
                    text="Listele"
                    className="listButton"
                  />
                </Col>
              </Row>
              <CgnDatatable
                data={this.state.productData}
                title={this.state.pageTitle}
                columns={[
                  {
                    name: "Fotoğraf",
                    selector: "image",
                    sortable: false,
                    width: "80px",
                    cell: (cell) => (
                      <div>
                        {cell.machineProductImage ? (
                          <Button
                            onClick={() =>
                              this.toggle(
                                cell.machineProductImage,
                                cell.machineProductName
                              )
                            }
                            className="modalButtonList"
                          >
                            <img
                              alt={cell.machineProductName}
                              src={`/Images/${cell.machineProductImage}`}
                              className="rdt_image rounded"
                            />
                          </Button>
                        ) : (
                          <img
                            alt={cell.machineProductName}
                            src={noImg}
                            className="rdt_image rdt_no_image rounded"
                          />
                        )}
                      </div>
                    ),
                  },
                  {
                    name: "Ürün Adet Bilgileri",
                    sortable: false,
                    cell: (row) => {
                      return (
                        <Table className="table table-responsive ">
                          <tbody>
                            <tr>
                              <th style={this.thStyle}>Depo</th>
                              <td colSpan={3}>{row.locationName}</td>
                            </tr>
                            <tr>
                              <th style={this.thStyle}>Ürün Kodu</th>
                              <td style={this.tdStyle}>
                                {row.machineProductCode}
                              </td>
                              <th style={this.thStyle2}>Ürün Adı</th>
                              <td>{row.machineProductName}</td>
                            </tr>
                            <tr>
                              <th style={this.thStyle}>Adet</th>
                              <td style={this.tdStyle}>{row.piece}</td>
                              <th style={this.thStyle2}>Kritik Adet</th>
                              <td>{row.criticalPiece}</td>
                            </tr>
                            <tr>
                              <th style={this.thStyle}>Sağlam Adet</th>
                              <td style={this.tdStyle}>{row.pieceDurable}</td>
                              <th style={this.thStyle2}>Arızalı Adet</th>
                              <td>{row.pieceDefective}</td>
                            </tr>
                          </tbody>
                        </Table>
                      );
                    },
                  },
                ]}
              />
            </Card>
          </Col>
        </Row>
        <Modal
          className="modal-xs"
          isOpen={this.state.isOpen}
          toggle={this.toggle}
        >
          <ModalHeader toggle={this.toggle}></ModalHeader>
          <img
            className="modalImage"
            src={`/Images/${this.state.image}`}
            style={fotoStyle}
            alt={this.state.name}
          />
        </Modal>
      </>
    );
  }
}

export default MachinePieceProductList;
